import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { serviceEndpoints } from '../../services/api/endpoints/service.endpoint';
import { Service } from '../../types/service';
import { logger } from '../../utils/logger';

export const useServices = () => {
  const [services, setServices] = useState<Service[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const selectedOrganizationId = useSelector(
    (state: RootState) => state.organizationContext.selectedOrganizationId
  );

  const fetchServices = useCallback(async () => {
    if (!selectedOrganizationId) return;

    setIsLoading(true);
    setError(null);

    try {
      const data = await serviceEndpoints.listServices(selectedOrganizationId);
      setServices(data);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to fetch services';
      setError(message);
      logger.error('Error fetching services:', err);
    } finally {
      setIsLoading(false);
    }
  }, [selectedOrganizationId]);

  useEffect(() => {
    fetchServices();
  }, [fetchServices]);

  return {
    services,
    isLoading,
    error,
    selectedOrganizationId,
    refetch: fetchServices,
  };
};
